export default __webpack_public_path__ + "static/media/icon_search_close.5fb2397c.svg";